<template>
  <NuxtLoadingIndicator />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useHead, useScriptEventPage, useScriptGoogleTagManager } from '#imports'

// ANALYTICS - START
const { proxy } = useScriptGoogleTagManager()
useScriptEventPage(({ path, title }) => {
  proxy.dataLayer.push({
    event: 'pageview',
    title,
    path
  })
})
useHead({
  link: [
    {
      rel: 'preconnect',
      href: 'https://consent.cookiebot.com',
      key: 'preconnect-cookiebot'
    }
  ]
})
// ANALYTICS - END

useHead({
  script: [
    {
      id: 'speculationrules',
      type: 'speculationrules',
      textContent: `
        {
          "prefetch": [
            {
              "where": {
                "href_matches": "/*"
              },
              "eagerness": "moderate"
            }
          ]
        }
      `
    }
  ]
})
</script>

<style>
@view-transition {
  navigation: auto;
}
</style>
